import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import Input from "../../../components/form/Input";
import StorageLocationAutocomplete from "./StorageLocationAutocomplete/StorageLocationAutocomplete";

const schema = Yup.object().shape({
  rackLocations: Yup.array().of(
    Yup.object().shape({
      warehouse_locations: Yup.array().min(1, "Required"),
    })
  ),
});

export default function RackLocationsForm({ asset, toggleModal, rackLocations, onSubmit }) {
  return (
    <Formik initialValues={{ rackLocations }} onSubmit={onSubmit} validationSchema={schema}>
      {({ values, handleSubmit, setFieldValue, isSubmitting }) => (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            {values.rackLocations.map((location, index) => (
              <React.Fragment key={index}>
                <Grid size={{ sm: 7 }}>
                  <StorageLocationAutocomplete
                    index={index}
                    name="rackLocations"
                    value={values.rackLocations[index]}
                    projectId={asset.project.id}
                    onChange={values => {
                      Object.entries(values).forEach(([key, value]) => {
                        setFieldValue(`rackLocations.${index}.${key}`, value);
                      });
                    }}
                  />
                </Grid>
                <Grid size={{ sm: 5 }}>
                  <Input
                    disabled
                    name={`rackLocations[${index}].sub_qty`}
                    label={`Sub QTY ${index + 1}`}
                  />
                </Grid>
              </React.Fragment>
            ))}
          </Grid>
          <Box mt={4} />
          <Box display="flex" justifyContent="flex-end" gap={1}>
            <Button color="primary" variant="outlined" onClick={toggleModal}>
              Close
            </Button>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              disabled={isSubmitting}
              startIcon={isSubmitting && <CircularProgress size={20} color="inherit" />}
            >
              Save
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
}
